const CTA = () => {
  return (
    <section className="relative z-10 py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-[900px] mx-auto bg-gradient-to-br from-primary to-primary-dark rounded-[24px] p-12 md:p-16 text-center relative overflow-hidden shadow-custom-lg">
          <div
            className="absolute inset-0"
            style={{
              background: 'radial-gradient(circle at 20% 30%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(0,163,224,0.15) 0%, transparent 50%)'
            }}
          ></div>

          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight">
              جاهز باش تبدأ التعلم؟
            </h2>
            <p className="text-lg md:text-xl text-white/95 mb-10 leading-relaxed">
              استكشف المحتوى التعليمي وابدأ رحلتك درك!
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-[600px] mx-auto">
              <a
                href="/courses"
                className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-white text-primary font-bold rounded-xl hover:bg-white/90 transition-all shadow-lg hover:shadow-xl hover:-translate-y-1"
              >
                <i className="fas fa-book-open text-xl"></i>
                <span>تصفح الدورات</span>
                <i className="fas fa-arrow-left group-hover:-translate-x-1 transition-transform"></i>
              </a>
              
              <a
                href="/storybooks"
                className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-bold rounded-xl border-2 border-white/30 hover:bg-white/20 transition-all hover:-translate-y-1"
              >
                <i className="fas fa-book text-xl"></i>
                <span>القصص المصورة</span>
                <i className="fas fa-arrow-left group-hover:-translate-x-1 transition-transform"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
